/**
 * Sponsoring aanvraag – client-side validatie + honeypot.
 * Als data-api-endpoint op de sectie staat: POST naar die API (mail met duidelijke titel).
 * Anders: formulier naar Shopify contactformulier (store mail).
 */
(function () {
  const PHONE_REG = /^[\d\s\-\+\(\)]{10,20}$/;
  const EMAIL_REG = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /** Form veldnaam -> API body key */
  var formToApiKeys = {
    'contact[name]': 'naam',
    'contact[Vereniging organisatie]': 'vereniging',
    'contact[Team]': 'team',
    'contact[Functie]': 'functie',
    'contact[phone]': 'telefoon',
    'contact[email]': 'email',
    'contact[Soort aanvraag]': 'soort_aanvraag',
    'contact[Naam evenement initiatief]': 'naam_evenement',
    'contact[Datum evenement]': 'datum_evenement',
    'contact[Locatie]': 'locatie',
    'contact[Omschrijving initiatief]': 'omschrijving',
    'contact[Doel aanvraag]': 'doel',
    'contact[Gewenste bijdrage]': 'bijdrage',
    'contact[Tegenprestatie zichtbaarheid]': 'tegenprestatie',
    'contact[Aantal deelnemers]': 'aantal_deelnemers',
    'contact[Verwacht aantal bezoekers]': 'aantal_bezoekers',
    'contact[Social media bereik]': 'social_media_bereik',
    'contact[Terugkerend evenement]': 'terugkerend_evenement',
    'contact[Eerdere sponsoring Club]': 'eerdere_sponsoring_club',
    'contact[Privacy akkoord]': 'privacy',
    'contact[Soort aanvraag omschrijving]': 'soort_aanvraag_omschrijving',
    'contact[Gewenste bijdrage omschrijving]': 'bijdrage_omschrijving',
    'website_url': 'website_url'
  };

  /** API error key -> form veldnaam (voor setFieldError) */
  var apiErrorKeyToFieldName = {};
  Object.keys(formToApiKeys).forEach(function (formName) {
    var apiKey = formToApiKeys[formName];
    if (apiKey !== 'website_url') apiErrorKeyToFieldName[apiKey] = formName;
  });

  var fieldNames = [
    'contact[name]',
    'contact[Vereniging organisatie]',
    'contact[Team]',
    'contact[Functie]',
    'contact[phone]',
    'contact[email]',
    'contact[Soort aanvraag]',
    'contact[Naam evenement initiatief]',
    'contact[Datum evenement]',
    'contact[Locatie]',
    'contact[Omschrijving initiatief]',
    'contact[Doel aanvraag]',
    'contact[Gewenste bijdrage]',
    'contact[Tegenprestatie zichtbaarheid]',
    'contact[Aantal deelnemers]',
    'contact[Verwacht aantal bezoekers]',
    'contact[Social media bereik]',
    'contact[Terugkerend evenement]',
    'contact[Eerdere sponsoring Club]',
    'contact[Privacy akkoord]',
    'contact[Soort aanvraag omschrijving]',
    'contact[Gewenste bijdrage omschrijving]'
  ];

  function getSectionRoot() {
    return document.querySelector('.sponsoring-aanvraag[data-section-id]');
  }

  function getApiEndpoint(root) {
    var url = root && root.getAttribute('data-api-endpoint');
    return (url && url.trim()) ? url.trim() : '';
  }

  function buildApiBody(form) {
    var fd = new FormData(form);
    var body = {};
    Object.keys(formToApiKeys).forEach(function (formName) {
      var apiKey = formToApiKeys[formName];
      var val = fd.get(formName);
      if (val !== null && val !== undefined) body[apiKey] = typeof val === 'string' ? val.trim() : String(val);
    });
    return body;
  }

  function getSectionId(root) {
    return root ? root.getAttribute('data-section-id') : null;
  }

  function getForm(root) {
    return root ? root.querySelector('form') : null;
  }

  function getSubmitBtn(root) {
    var id = getSectionId(root);
    return id ? root.querySelector('#sponsoring-submit-' + id) : null;
  }

  function getGlobalError(root) {
    var id = getSectionId(root);
    return id ? root.querySelector('#sponsoring-global-error-' + id) : null;
  }

  function showGlobalError(root, message) {
    var el = getGlobalError(root);
    var textEl = el && el.querySelector('[id^="sponsoring-global-error-text"]');
    if (el && textEl) {
      textEl.textContent = message || '';
      el.hidden = false;
    }
  }

  function hideGlobalError(root) {
    var el = getGlobalError(root);
    if (el) el.hidden = true;
  }

  var nameToErrorSuffix = {
    'contact[name]': 'naam',
    'contact[Vereniging organisatie]': 'vereniging',
    'contact[Team]': 'team',
    'contact[Functie]': 'functie',
    'contact[phone]': 'telefoon',
    'contact[email]': 'email',
    'contact[Soort aanvraag]': 'soort_aanvraag',
    'contact[Naam evenement initiatief]': 'naam_evenement',
    'contact[Datum evenement]': 'datum_evenement',
    'contact[Locatie]': 'locatie',
    'contact[Omschrijving initiatief]': 'omschrijving',
    'contact[Doel aanvraag]': 'doel',
    'contact[Gewenste bijdrage]': 'bijdrage',
    'contact[Tegenprestatie zichtbaarheid]': 'tegenprestatie',
    'contact[Aantal deelnemers]': 'aantal_deelnemers',
    'contact[Verwacht aantal bezoekers]': 'aantal_bezoekers',
    'contact[Social media bereik]': 'social_media_bereik',
    'contact[Terugkerend evenement]': 'terugkerend_evenement',
    'contact[Eerdere sponsoring Club]': 'eerdere_sponsoring',
    'contact[Privacy akkoord]': 'privacy',
    'contact[Soort aanvraag omschrijving]': 'soort_aanvraag_omschrijving',
    'contact[Gewenste bijdrage omschrijving]': 'bijdrage_omschrijving'
  };

  function setFieldError(root, name, message) {
    var id = getSectionId(root);
    var form = getForm(root);
    var errorEl = id ? root.querySelector('#error-' + (nameToErrorSuffix[name] || name) + '_' + id) : null;
    if (errorEl) {
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }
  }

  function validateEmail(v) {
    return typeof v === 'string' && EMAIL_REG.test(v.trim());
  }

  function validatePhone(v) {
    return typeof v === 'string' && PHONE_REG.test(v.replace(/\s/g, ''));
  }

  function validate(root) {
    var form = getForm(root);
    if (!form) return { valid: false, errors: {} };
    var fd = new FormData(form);
    var errors = {};
    var honeypot = (fd.get('website_url') || '').toString().trim();
    if (honeypot) {
      errors._honeypot = true;
      return { valid: false, errors: errors };
    }

    var naam = (fd.get('contact[name]') || '').toString().trim();
    if (!naam) errors['contact[name]'] = 'Vul voor- en achternaam in.';
    var vereniging = (fd.get('contact[Vereniging organisatie]') || '').toString().trim();
    if (!vereniging) errors['contact[Vereniging organisatie]'] = 'Vul vereniging/organisatie in.';
    var team = (fd.get('contact[Team]') || '').toString().trim();
    if (!team) errors['contact[Team]'] = 'Vul team in.';
    var functie = (fd.get('contact[Functie]') || '').toString().trim();
    if (!functie) errors['contact[Functie]'] = 'Vul functie in.';
    var telefoon = (fd.get('contact[phone]') || '').toString().trim();
    if (!telefoon) errors['contact[phone]'] = 'Vul telefoonnummer in.';
    else if (!validatePhone(telefoon)) errors['contact[phone]'] = 'Ongeldig telefoonnummer.';
    var email = (fd.get('contact[email]') || '').toString().trim();
    if (!email) errors['contact[email]'] = 'Vul e-mailadres in.';
    else if (!validateEmail(email)) errors['contact[email]'] = 'Ongeldig e-mailadres.';
    var soort = (fd.get('contact[Soort aanvraag]') || '').toString().trim();
    if (!soort) errors['contact[Soort aanvraag]'] = 'Kies een soort aanvraag.';
    if (soort === 'Overig') {
      var soortOmsch = (fd.get('contact[Soort aanvraag omschrijving]') || '').toString().trim();
      if (!soortOmsch) errors['contact[Soort aanvraag omschrijving]'] = 'Vul omschrijving in.';
    }
    var naamEv = (fd.get('contact[Naam evenement initiatief]') || '').toString().trim();
    if (!naamEv) errors['contact[Naam evenement initiatief]'] = 'Vul naam evenement/initiatief in.';
    var datum = (fd.get('contact[Datum evenement]') || '').toString().trim();
    if (!datum) errors['contact[Datum evenement]'] = 'Vul datum evenement in.';
    var locatie = (fd.get('contact[Locatie]') || '').toString().trim();
    if (!locatie) errors['contact[Locatie]'] = 'Vul locatie in.';
    var omschrijving = (fd.get('contact[Omschrijving initiatief]') || '').toString().trim();
    if (!omschrijving) errors['contact[Omschrijving initiatief]'] = 'Vul omschrijving in.';
    var doel = (fd.get('contact[Doel aanvraag]') || '').toString().trim();
    if (!doel) errors['contact[Doel aanvraag]'] = 'Vul doel van de aanvraag in.';
    var bijdrage = (fd.get('contact[Gewenste bijdrage]') || '').toString().trim();
    if (!bijdrage) errors['contact[Gewenste bijdrage]'] = 'Kies gewenste bijdrage.';
    if (bijdrage === 'Anders') {
      var bijdrageOmsch = (fd.get('contact[Gewenste bijdrage omschrijving]') || '').toString().trim();
      if (!bijdrageOmsch) errors['contact[Gewenste bijdrage omschrijving]'] = 'Vul omschrijving gewenste bijdrage in.';
    }
    var tegenprestatie = (fd.get('contact[Tegenprestatie zichtbaarheid]') || '').toString().trim();
    if (!tegenprestatie) errors['contact[Tegenprestatie zichtbaarheid]'] = 'Vul tegenprestatie/zichtbaarheid in.';
    var deelnemers = (fd.get('contact[Aantal deelnemers]') || '').toString().trim();
    if (deelnemers === '' || isNaN(Number(deelnemers)) || Number(deelnemers) < 0)
      errors['contact[Aantal deelnemers]'] = 'Vul aantal deelnemers in (0 of meer).';
    var bezoekers = (fd.get('contact[Verwacht aantal bezoekers]') || '').toString().trim();
    if (bezoekers === '' || isNaN(Number(bezoekers)) || Number(bezoekers) < 0)
      errors['contact[Verwacht aantal bezoekers]'] = 'Vul verwacht aantal bezoekers in (0 of meer).';
    var bereik = (fd.get('contact[Social media bereik]') || '').toString().trim();
    if (!bereik) errors['contact[Social media bereik]'] = 'Vul social media bereik in.';
    var terugkerend = (fd.get('contact[Terugkerend evenement]') || '').toString().trim();
    if (!terugkerend) errors['contact[Terugkerend evenement]'] = 'Geef aan of dit een terugkerend evenement is.';
    var eerdereSponsoring = (fd.get('contact[Eerdere sponsoring Club]') || '').toString().trim();
    if (!eerdereSponsoring) errors['contact[Eerdere sponsoring Club]'] = 'Geef aan of jullie eerder sponsoring van Club hebben ontvangen.';
    var privacy = fd.get('contact[Privacy akkoord]');
    if (!privacy) errors['contact[Privacy akkoord]'] = 'Je moet akkoord gaan met de privacyverklaring.';

    return {
      valid: Object.keys(errors).length === 0,
      errors: errors
    };
  }

  function updateSubmitButton(root) {
    /* Knop blijft altijd klikbaar; validatie gebeurt bij submit. */
  }

  function showErrors(root, errors) {
    fieldNames.forEach(function (name) {
      setFieldError(root, name, errors[name] || '');
    });
  }

  function clearAllFieldErrors(root) {
    fieldNames.forEach(function (name) {
      setFieldError(root, name, '');
    });
  }

  function toggleConditionalFields(root) {
    var id = getSectionId(root);
    if (!id) return;
    var soortSelect = root.querySelector('#soort_aanvraag_' + id);
    var bijdrageSelect = root.querySelector('#bijdrage_' + id);
    var soortWrapper = root.querySelector('#soort_overig_wrapper_' + id);
    var bijdrageWrapper = root.querySelector('#bijdrage_anders_wrapper_' + id);
    var soortInput = root.querySelector('#soort_aanvraag_omschrijving_' + id);
    var bijdrageInput = root.querySelector('#bijdrage_omschrijving_' + id);

    if (soortSelect && soortWrapper && soortInput) {
      var showSoort = soortSelect.value === 'Overig';
      soortWrapper.hidden = !showSoort;
      soortInput.required = showSoort;
      if (!showSoort) {
        soortInput.value = '';
        setFieldError(root, 'contact[Soort aanvraag omschrijving]', '');
      }
    }
    if (bijdrageSelect && bijdrageWrapper && bijdrageInput) {
      var showBijdrage = bijdrageSelect.value === 'Anders';
      bijdrageWrapper.hidden = !showBijdrage;
      bijdrageInput.required = showBijdrage;
      if (!showBijdrage) {
        bijdrageInput.value = '';
        setFieldError(root, 'contact[Gewenste bijdrage omschrijving]', '');
      }
    }
  }

  function initSection(root) {
    var form = getForm(root);
    if (!form) return;

    hideGlobalError(root);
    clearAllFieldErrors(root);
    toggleConditionalFields(root);

    var id = getSectionId(root);
    if (id) {
      var soortSelect = root.querySelector('#soort_aanvraag_' + id);
      var bijdrageSelect = root.querySelector('#bijdrage_' + id);
      if (soortSelect) soortSelect.addEventListener('change', function () { toggleConditionalFields(root); });
      if (bijdrageSelect) bijdrageSelect.addEventListener('change', function () { toggleConditionalFields(root); });
    }

    form.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.addEventListener('input', function () {
        setFieldError(root, el.name, '');
        updateSubmitButton(root);
      });
      el.addEventListener('change', function () {
        setFieldError(root, el.name, '');
        updateSubmitButton(root);
      });
    });

    updateSubmitButton(root);

    form.addEventListener('submit', function (e) {
      var result = validate(root);
      if (!result.valid) {
        e.preventDefault();
        clearAllFieldErrors(root);
        showErrors(root, result.errors);
        if (result.errors._honeypot) {
          showGlobalError(root, 'Verzenden mislukt. Probeer het later opnieuw.');
        } else {
          var firstErrorEl = root.querySelector('.field-error:not([hidden])');
          var field = firstErrorEl && firstErrorEl.closest('.field');
          if (field) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      hideGlobalError(root);
      clearAllFieldErrors(root);

      var apiEndpoint = getApiEndpoint(root);
      if (apiEndpoint) {
        e.preventDefault();
        var submitBtn = getSubmitBtn(root);
        var successApiEl = getSectionId(root) ? root.querySelector('#sponsoring-success-api-' + getSectionId(root)) : null;
        var btnText = submitBtn ? submitBtn.querySelector('span') : null;
        var originalText = btnText ? btnText.textContent : '';

        function resetButton() {
          if (submitBtn) submitBtn.disabled = false;
          if (btnText) btnText.textContent = originalText;
        }

        function fallbackFormSubmit() {
          resetButton();
          showGlobalError(root, 'Verzenden via API mislukt. Formulier wordt nu per e-mail verzonden.');
          setTimeout(function () {
            form.submit();
          }, 800);
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          if (btnText) btnText.textContent = 'Bezig met verzenden…';
        }
        var body = buildApiBody(form);

        var timeoutId = setTimeout(function () {
          timeoutId = null;
          fallbackFormSubmit();
        }, 20000);

        fetch(apiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }).catch(function () { return { ok: false, data: {} }; }); })
          .then(function (result) {
            if (timeoutId) clearTimeout(timeoutId);
            if (result.ok && result.data && result.data.success) {
              resetButton();
              var formEl = form;
              for (var i = 0; i < formEl.children.length; i++) {
                var child = formEl.children[i];
                if (child !== successApiEl) child.hidden = true;
              }
              if (successApiEl) successApiEl.hidden = false;
            } else {
              resetButton();
              fallbackFormSubmit();
            }
          })
          .catch(function () {
            if (timeoutId) clearTimeout(timeoutId);
            fallbackFormSubmit();
          });
      }
    });
  }

  function init() {
    var root = getSectionRoot();
    if (root) initSection(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
